import { Address } from '~/lib/api/me/types';
import { EditType } from '../../components/smartsend/item/EditType';
import { BaseEvents } from './EventEmitter';
export interface ManifestRefreshType extends BaseEvents {}
export interface BookEventType extends BaseEvents {}
export interface DownloadEventType extends BaseEvents {}
export type OpenHelpEventTypeFeature = 'HAVINGISSUES';
export interface TasksEventType extends BaseEvents {}
export interface NotificationsEventType extends BaseEvents {}
export interface EditEventType extends BaseEvents {
  Id?: string;
  Action: EditType;
  SendTo?: Address;
}
export const Consts = {
  Downloads: 'openDownloads',
  Edit: 'openEdit',
  Book: 'bookAction',
  Task: 'setTask',
  Notifications: 'setNotifications',
  ManifestRefresh: 'refreshManifest'
};
